import './App.css';
import Navbar from './components/Navbar';

import Footer from './components/Footer.jsx';
import Homepage from './pages/Homepage.jsx';
import About from './pages/About.jsx';
import { Route, Routes } from 'react-router-dom';
import OurListing from './pages/OurListing.jsx';
import OurBusiness from './pages/OurBusiness.jsx';
import SellWithUs from './pages/SellWithUs.jsx';
import Contact from './pages/Contact.jsx';
import JoinTalentCommunity from './pages/JoinTalentCommunity.jsx';
import GivingBack from './pages/GivingBack.jsx';
function App() {
  return (
    <div className="App">
     <Navbar/>
     
     <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<About />} />
        <Route path="/our-listing" element={<OurListing />} />
        <Route path="/our-business" element={<OurBusiness />} />
        <Route path="/sell-with-us" element={<SellWithUs />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/talentcommunity" element={<JoinTalentCommunity />} />
        <Route path="/giving-back" element={<GivingBack />} />
      </Routes>
     <Footer/>
    </div>
  );
}

export default App;
